import { useEffect, useState } from 'react';

const useSellerBlockModal = (blockings = []) => {
  const [showSellerBlockModal, setShowSellerBlockModal] = useState(false);
  const toggleShowSellerBlockModal = () => {
    setShowSellerBlockModal(!showSellerBlockModal);
  };

  const setBlockUnderstanding = (blockUnderstanding) =>
    sessionStorage.setItem('blockUnderstanding', JSON.stringify(blockUnderstanding));

  const setConfirmationBlockUnderstanding = () => {
    setBlockUnderstanding({
      confirmation: true,
      date: new Date(),
    });
    toggleShowSellerBlockModal();
  };

  const getConfirmationAndDateBlockUnderstanding = () => {
    const confirmationBlockUnderstanding = JSON.parse(sessionStorage.getItem('blockUnderstanding'));
    const confirmation = confirmationBlockUnderstanding
      ? confirmationBlockUnderstanding.confirmation
      : false;
    const date =
      confirmationBlockUnderstanding?.date && new Date(confirmationBlockUnderstanding?.date);

    return { confirmation, date };
  };

  useEffect(() => {
    const { confirmation, date } = getConfirmationAndDateBlockUnderstanding();
    const currentlyDate = new Date();
    currentlyDate.setHours(0, 0, 0, 0);
    if (
      blockings.length > 0 &&
      (typeof date === 'undefined' || !confirmation || (confirmation && date < currentlyDate))
    ) {
      setShowSellerBlockModal(true);
      setBlockUnderstanding({
        confirmation: false,
        date,
      });
    }
  }, [blockings]);

  return {
    showSellerBlockModal,
    toggleShowSellerBlockModal,
    setConfirmationBlockUnderstanding,
  };
};

export default useSellerBlockModal;
